"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var controlled_input_1 = require("./controlled_input");
var uncontrolled_input_1 = require("./uncontrolled_input");
var form_group_1 = require("./form_group");
var bind_1 = require("../bind");
var FormGroupWithInput = /** @class */ (function (_super) {
    tslib_1.__extends(FormGroupWithInput, _super);
    function FormGroupWithInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showPassword: false,
            inputLength: null,
        };
        return _this;
    }
    FormGroupWithInput.prototype.shouldBeControlled = function () {
        return !!this.props.updateField || !!this.props.onBlur;
    };
    FormGroupWithInput.prototype.getInputType = function () {
        // if showing password, just go with the default of 'text'
        if (this.props.inputType === 'password' && this.state.showPassword)
            return 'text';
        return this.props.inputType || 'text';
    };
    FormGroupWithInput.prototype.togglePassword = function (evt) {
        evt.preventDefault();
        this.setState({ showPassword: !this.state.showPassword });
    };
    FormGroupWithInput.prototype.getCurrentLength = function () {
        if (this.shouldBeControlled()) {
            return this.props.value ? this.props.value.length : 0;
        }
        return this.state.inputLength || 0;
    };
    FormGroupWithInput.prototype.onChange = function (evt) {
        this.setState({ inputLength: evt.target.value.length });
    };
    FormGroupWithInput.prototype.renderToggler = function () {
        return (React.createElement("a", { className: "form-group__password-container__toggle", onClick: this.togglePassword, href: "#" }));
    };
    FormGroupWithInput.prototype.renderControlledInput = function () {
        return (React.createElement(controlled_input_1.default, { autoCapitalize: this.props.autoCapitalize, autoComplete: this.props.autoComplete, autoCorrect: this.props.autoCorrect, autoFocus: this.props.autoFocus, currencyPrefix: this.props.currencyPrefix, currencySuffix: this.props.currencySuffix, disabled: this.props.disabled, fieldName: this.props.fieldName || this.props.inputName, id: this.props.id, inputName: this.props.inputName, inputType: this.getInputType(), inputValue: this.props.value, maxLength: this.props.maxLength, numberOnly: this.props.numberOnly, pattern: this.props.pattern, placeholder: this.props.placeholder, required: this.props.required, spellCheck: this.props.spellCheck, updateField: this.props.updateField, onBlur: this.props.onBlur }));
    };
    FormGroupWithInput.prototype.renderUncontrolledInput = function () {
        return (React.createElement(uncontrolled_input_1.default, { autoCapitalize: this.props.autoCapitalize, autoComplete: this.props.autoComplete, autoCorrect: this.props.autoCorrect, autoFocus: this.props.autoFocus, currencyPrefix: this.props.currencyPrefix, currencySuffix: this.props.currencySuffix, disabled: this.props.disabled, id: this.props.id || this.props.inputName, inputName: this.props.inputName, inputType: this.getInputType(), maxLength: this.props.maxLength, pattern: this.props.pattern, placeholder: this.props.placeholder, required: this.props.required, spellCheck: this.props.spellCheck, numberOnly: this.props.numberOnly, onChange: this.onChange }));
    };
    FormGroupWithInput.prototype.renderInput = function () {
        if (this.shouldBeControlled())
            return this.renderControlledInput();
        return this.renderUncontrolledInput();
    };
    FormGroupWithInput.prototype.renderInputContainer = function () {
        if (this.props.inputType !== 'password')
            return this.renderInput();
        var classes = classNames('form-group__password-container', { 'form-group__password-container--shown': this.state.showPassword });
        return (React.createElement("div", { className: classes },
            this.renderInput(),
            this.renderToggler()));
    };
    FormGroupWithInput.prototype.renderHelpText = function () {
        var maxLength = this.props.maxLength;
        var current = this.getCurrentLength();
        return (React.createElement("span", { "data-helptext": true },
            this.props.displayCharacterCount && !!maxLength &&
                React.createElement("span", { className: "mr-2" },
                    current,
                    " / ",
                    maxLength),
            this.props.helpText));
    };
    FormGroupWithInput.prototype.render = function () {
        return (React.createElement(form_group_1.default, { label: this.props.label, inputName: this.props.inputName, errorText: this.props.errorText, helpText: this.renderHelpText(), tagOptional: this.props.tagOptional, tagRecommended: this.props.tagRecommended, tagRequired: this.props.tagRequired }, this.renderInputContainer()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], FormGroupWithInput.prototype, "togglePassword", null);
    tslib_1.__decorate([
        bind_1.default
    ], FormGroupWithInput.prototype, "onChange", null);
    return FormGroupWithInput;
}(React.Component));
exports.default = FormGroupWithInput;
//# sourceMappingURL=form_group_with_input.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/form_group_with_input.js
// module id = oK2M
// module chunks = 20 21 22